<template>
  <b-button variant="outline-primary" @click="createUser">Button</b-button>
</template>
<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "Configuration",
  methods: {
    createUser() {
        var email = "cgs.cesar@gmail.com";
        var password = "123456";
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log("watermelon", errorCode);
          console.log(errorMessage);
          // ...
        });
    }
  }
};
</script>